import { render, staticRenderFns } from "./etapa_9.vue?vue&type=template&id=ea35e37e&scoped=true&"
import script from "./etapa_9.vue?vue&type=script&lang=js&"
export * from "./etapa_9.vue?vue&type=script&lang=js&"
import style0 from "./etapa_9.vue?vue&type=style&index=0&id=ea35e37e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea35e37e",
  null
  
)

export default component.exports